<template>
	<b-container class="mt-3">
		<b-row>
			<b-col sm="12" md="8" offset-md="2">
				<div class="bg-light rounded dshadow mb-3" style="overflow:hidden">
					<div class="p-3">
						<edit-base :data="data"/>
					</div>
					<div class="bg-theme p-1"></div>
				</div>
			</b-col>
		</b-row>
		<b-row>
			<b-col sm="12" md="8" offset-md="2">
				<div class="bg-light rounded dshadow" style="overflow:hidden">
					<div class="p-3">
						<edit-subtype :data="data"/>
					</div>
					<div class="bg-theme p-1"></div>
				</div>
				
			</b-col>
		</b-row>

	</b-container>


</template>

<script>

	import SART from "./inspectors/sart";
	import EditBase from "./edit-base";
	import EditSubtype from "./edit-subtype";

	export default {
		props:{
			"data":Object
		},
		components:{
			EditBase,
			EditSubtype
		}
	}
</script>

<style lang="scss" scoped>


	@import "@/theme/mixins/dropShadow.scss";

	$theme-color:#943acf;
	

	.bg-theme{
		background-color: $theme-color;
	}

	.dshadow{ @include dropShadow(5px, 5px, 1px, rgba(0, 0, 0, 0.157)); }

</style>